<footer role="contentinfo">
	<p class="text-center">© 2020 Ford Motor Company. All rights reserved.</p>
	<p class="text-center">Angular: v{{version}}</p>
</footer>

<div class="jumbotron text-center" style="font-size: 130%; padding: 10%;">
  @if (isConnectionError) {
    <h2 id="connectionError">
      <span class="error" style="color: red">
        {{ 'label.connectionError' | translate }}
      </span>
    </h2>
    <p>	{{ 'label.noticeConnection' | translate }}</p>
  } @else {
    <h2 id="noAccess">
      <span class="error" style="color: red">
        {{ 'label.access' | translate }}
      </span>
    </h2>
    <p>	{{ 'label.noticeAccess' | translate }}</p>
    <p>	{{ 'label.requestPermission' | translate }}</p>
    <p>
      <a [href]="url" pButton label="{{ 'button.request' | translate }}" class="ui-button-success">{{ 'button.request' | translate }}</a>
    </p>
  }
  <p>
    <button type="button" pButton label="{{ 'button.retry' | translate }}" (click)="retry()">{{ 'button.retry' | translate }}</button>
  </p>
  <br>
</div>
